export default "/images/message-square.svg?da92dd7a0359c3b9e6fbb8b09043b968";